export { default } from './getDataSelector'
